export default __webpack_public_path__ + "static/video2-505c993d2cedd2413aebeeaa7426f821.jpg";